const initRewardShipment = {
  rewardShipments: [],
  rewardShipmentDetails: [],
  rewardShipmentUserCatalogs: [],
  currentPage: 1,
  totalPage: 1,
  limitPage: 10,
  lengthPage: 1,
  searchValue: "",
  filterTenantPage: "",
  isFormLoading: false,
  isRewardShipmentDetailLoading: false,
};

export const rewardShipmentReducer = (
  state = initRewardShipment,
  action: any
) => {
  if (action.type === "SET_REWARD_SHIPMENT") {
    return {
      ...state,
      rewardShipments: action.value,
    };
  }
  if (action.type === "SET_REWARD_SHIPMENT_DETAIL") {
    return {
      ...state,
      rewardShipmentDetails: action.value,
    };
  }
  if (action.type === "SET_REWARD_SHIPMENT_USER_CATALOG") {
    return {
      ...state,
      rewardShipmentUserCatalogs: action.value,
    };
  }
  if (action.type === "SET_REWARD_SHIPMENT_CURRENT_PAGE") {
    return {
      ...state,
      currentPage: action.currentPage,
    };
  }
  if (action.type === "SET_REWARD_SHIPMENT_PAGE") {
    return {
      ...state,
      totalPage: action.totalPage,
      limitPage: action.limitPage,
      lengthPage: action.lengthPage,
    };
  }
  if (action.type === "SET_SEARCH_REWARD_SHIPMENT") {
    return {
      ...state,
      searchValue: action.searchValue,
    };
  }
  if (action.type === "SET_REWARD_SHIPMENT_FILTER_PAGE") {
    return {
      ...state,
      filterTenantPage: action.filterTenantPage,
    };
  }
  if (action.type === "SET_FORM_LOADING") {
    return {
      ...state,
      isFormLoading: action.value,
    };
  }
  if (action.type === "SET_REWARD_SHIPMENT_DETAIL_LOADING") {
    return {
      ...state,
      isRewardShipmentDetailLoading: action.value,
    };
  }
  return state;
};
